<template>
  <div class="sqm-announcement" :class="{ shadow, 'sqm-announcement--auto-height': data['content'][index].autoHeight }" v-if="show">
    <div class="sqm-announcement-header">
      <div class="sqm-announcement-text">
        {{ data['content'][index].title }}
      </div>
      <div class="sqm-announcement-close" @click="close">
        <close theme="outline" size="20" class="haier-dialog--header-close" />
      </div>
    </div>
    <div class="sqm-announcement-body">
      <div class="sqm-announcement-title">
        {{ data['content'][index].subheading }}
      </div>
      <template v-for="temp in data['content'][index].child">
        <div class="sqm-announcement-small-title">
          {{ temp.smallTitle }}
        </div>
        <div class="sqm-announcement-value" v-for="item in temp.value" v-html="item.value ? item.value : item" :class="item?.red ? 'dangerColor' : ''"></div>
      </template>
      <div class="sqm-announcement-note" v-html="data['content'][index].note"></div>
      <template v-for="temp in data['content'][index].child2">
        <div class="sqm-announcement-small-title">
          {{ temp.smallTitle }}
        </div>
        <div class="sqm-announcement-value" v-for="item in temp.value" v-html="item.value ? item.value : item" :class="item?.red ? 'dangerColor' : ''"></div>
      </template>
    </div>
    <div class="sqm-announcement-footer">
      <div v-show="data.checkbox">
        <el-checkbox v-model="check">{{ h_i18n('59fc4abd652cc7aabb41dee7e38961e5') }}</el-checkbox>
      </div>
      <div v-show="data.show">
        <el-button type="primary" size="small" @click="next">{{ h_i18n('397027aadeb1a8dc2d6c17dd7cf10650') }}</el-button>
      </div>
    </div>
  </div>
</template>



<script>
import {defineComponent, onMounted, ref} from 'vue';
import { useI18n } from 'vue-i18n';


export default defineComponent({
  name: 'Announcement',
  props: {
    data: {
      type: Object
    },
    shadow: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {

    const { t } = useI18n();

    const show = ref(true);

    const check = ref(false);

    const index = ref(0);

    const close = () => {
      show.value = false;

      localStorage.setItem(props.data.id, check.value.toString());

    };

    const h_i18n = (code) => {
      return t(code);
    };

    const next = () => {
      if (index.value === props.data['content'].length - 1) {
        index.value = 0;
      } else {
        index.value++;
      }
    };

    onMounted(() => {
      show.value = localStorage.getItem(props.data.id) !== 'true';
    });


    return {
      show,
      close,
      check,
      index,
      next,
      h_i18n
    };
  }
});
</script>

<style scoped lang="scss">
.dangerColor {
  color: #d74c4d !important;
}

.sqm-announcement {
  background-color: #fff;
  width: 780px;
  height: 500px;
  overflow-y: auto;
  position: fixed;
  z-index: 99999;
  // top: 375px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  border-radius: 4px;

  &.sqm-announcement--auto-height {
    max-width: calc(100vw - 40px);
    height: auto;
    max-height: calc(100vh - 100px);
    top: 80px;
    transform: translate(-50%, 0);
    box-sizing: border-box;
  }


  .sqm-announcement-header {
    height: 50px;
    width: 100%;
    display: flex;
    flex: none;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ededed;

    .sqm-announcement-text {
      font-size: 20px;
      margin-left: 10px;
      font-weight: bold;
      color: #53616e;
      display: flex;
      justify-content: center;
      flex: 1;
    }

    .sqm-announcement-close {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      flex: none;

      .i-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .sqm-announcement-body {
    padding: 20px;
    box-sizing: border-box;
    font-size: 16px;
    flex: 1;

    .sqm-announcement-title {
      text-indent: 2em;
      font-size: 12px;
      color: #53616e;
    }

    .sqm-announcement-small-title {
      color: #53616e;
      font-size: 18px;
      font-weight: bold;
      margin: 20px 0;
    }

    .sqm-announcement-value {
      margin: 10px 0;
      text-indent: 2em;
      color: #53616e;
      font-size: 12px;
    }
  }

  .sqm-announcement-footer {
    height: 40px;
    flex: none;
    padding: 10px 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.shadow {
  box-shadow: 0 0 10px 1px #3471FF;
}
@media (max-width: 767px) {
  .sqm-announcement {
    zoom: 0.8;
    overflow: auto;
  }
}
@media (max-width: 480px) {
  .hdy-content {
    zoom: 0.6;
    overflow: auto;
  }
}
</style>
